var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-button',{staticClass:"btn-icon",attrs:{"variant":"flat-secondary"},on:{"click":_vm.toAnotherPath}},[_c('feather-icon',{staticClass:"text-body",attrs:{"badge":_vm.itemsCount,"icon":"ShoppingCartIcon","size":"21"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }